// extracted by mini-css-extract-plugin
module.exports = {"hover":"Star_hover__3_6M9","hover__no-hover":"Star_hover__no-hover__2YCf3","hover__hover":"Star_hover__hover__3iEPi"};